import { render, staticRenderFns } from "./RebateIndex.vue?vue&type=template&id=23460693&scoped=true"
import script from "./RebateIndex.vue?vue&type=script&lang=js"
export * from "./RebateIndex.vue?vue&type=script&lang=js"
import style0 from "./RebateIndex.vue?vue&type=style&index=0&id=23460693&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23460693",
  null
  
)

export default component.exports